export default __webpack_public_path__ + "static/media/biggoal.75a045dc.png";